import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../ui/Button";
import { StoryCardProps } from "../../types/screensTypes";
import styles from "./MuseumStoryCard.module.css";

const StoryCard: React.FC<StoryCardProps> = ({ name, position, onClick, onDelete, dragHandleProps }) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    return (
        <div className={styles.card}>
            <div className={styles.top}>
                <div className={styles.dragHandle} {...dragHandleProps}>
                    <span>⠿</span>
                </div>
                <Button
                    label={t("delete")}
                    onClick={() => {
                        const confirmed = window.confirm(t("deleteConfirmation"));
                        if (confirmed) {
                            onDelete();
                        }
                    }}
                    isSmall
                    variant="danger"
                    shape="pill"
                    className={styles.deleteBtn}
                    preventDefault
                />
            </div>
            <div
                className={styles.content}
                onClick={(e) => {
                    e.preventDefault();
                    onClick();
                }}
            >
                <p className={styles.name}>{name}</p>
                <p className={styles.position}>
                    {t("positionWithSemicolon")} {position}
                </p>
            </div>
        </div>
    );
};

export default StoryCard;
